import React, {useState} from 'react';
import PropTypes from 'prop-types';
import LightBulb from '@learningblocks/exp-constants/lib/Images/lighbulb.svg';
import MoveIcon from '@learningblocks/exp-constants/lib/Images/move.svg';
import TrashCan from '@learningblocks/exp-constants/lib/Images/mini-trash-icon.svg';
import {Image} from '@learningblocks/storybook-components';
import {CardModalWindow} from '../SharedComponents/CardModalWindow';
import {CardModalContent} from '../SharedComponents/CardModalContent';
import './style.scss';

/**
 * Experimental-Design HexagonCard component:
 */
export function HexagonCard(props) {
  const [isModalOpen, toggleModal] = useState(false);

  const setModalOpen = () => {
    toggleModal(true);
  };

  const setModalClose = () => {
    toggleModal(false);
  };

  const addCardButton = () =>
    props.addCard && (
      <>
        <div className='hexagon-top--wrap' />
        <Image src={MoveIcon} alt='move-card-icon' onClick={props.addCard} />
      </>
    );

  const removeCardButton = () =>
    props.removeCard && (
      <>
        <div className='hexagon-top--wrap' />
        <Image
          src={TrashCan}
          alt='delete-card-icon'
          onClick={props.removeCard}
        />
      </>
    );

  return (
    <>
      <div className='hexagon'>
        <div className='hexagon-top'>
          {addCardButton()}
          {removeCardButton()}
        </div>
        <div className='hexagon-middle'>
          <Image src={props.image} alt={props.title} />
          <span>{props.title}</span>
        </div>
        <div className='hexagon-bottom' onClick={setModalOpen}>
          <Image src={LightBulb} alt='modal-button' />
        </div>
      </div>
      <CardModalWindow
        isModalOpen={isModalOpen}
        modalTitle={props.modal.title}
        setModalClose={setModalClose}>
        <CardModalContent components={props.modal.components} />
      </CardModalWindow>
    </>
  );
}

HexagonCard.propTypes = {
  /**
   * String representing type of component
   */
  type: PropTypes.string,
  /**
   * callback function to be executed when card is added as next step in DesignSection
   * Prop should be null if addCard icon not required
   */
  addCard: PropTypes.func,
  /**
   * callback function to be executed when card needs to be removed from design section tree
   * Prop should be null if removeCard icon not required
   */
  removeCard: PropTypes.func,
  /**
   * Url to the small card icon image
   */
  image: PropTypes.string.isRequired,
  /**
   * Title of the card
   */
  title: PropTypes.string.isRequired,
  /**
   * Data to be displayed in the modal
   */
  modal: PropTypes.shape({
    title: PropTypes.string.isRequired,
    components: PropTypes.array.isRequired,
  }).isRequired,
};

HexagonCard.defaultProps = {
  addCard: undefined,
  removeCard: undefined,
  type: 'LINK_HEXAGON_MODAL',
  image: '',
  title: '',
  modal: {components: [], title: ''},
};
